import type { RouteRecord } from "vite-react-ssg";
import Layout from "./Layout";
import { Home } from "./pages/Home";
import { NotFound } from "./pages/NotFound";
import { getPosts } from "./lib/wordpress";

// Home is not lazy: it's the landing page most visits hit first, so deferring
// it behind an extra chunk request would delay its own LCP for no benefit —
// there's no other page to save bytes for on a first visit to "/".
export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    entry: "src/Layout.tsx",
    children: [
      { index: true, Component: Home },
      {
        path: "sobre",
        lazy: () => import("./pages/Sobre").then((m) => ({ Component: m.Sobre })),
      },
      {
        path: "servicos",
        lazy: () => import("./pages/Servicos").then((m) => ({ Component: m.Servicos })),
      },
      {
        path: "blog",
        lazy: () => import("./pages/BlogList").then((m) => ({ Component: m.BlogList, loader: m.loader })),
        errorElement: <NotFound />,
      },
      {
        path: "blog/:slug",
        lazy: () => import("./pages/BlogPost").then((m) => ({ Component: m.BlogPost, loader: m.loader })),
        errorElement: <NotFound />,
        getStaticPaths: async () => {
          const posts = await getPosts(100);
          return posts.map((post) => `blog/${post.slug}`);
        },
      },
      { path: "*", Component: NotFound },
    ],
  },
];
